export default "__VITE_ASSET__CrISawa___"